import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ steps, currentStep }) => {
  const currentIndex = steps?.findIndex(step => step?.id === currentStep);

  return (
    <div className="card">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            {/* Step */}
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                  index < currentIndex
                    ? 'bg-success text-white'
                    : index === currentIndex
                    ? 'bg-primary text-white' :'bg-muted text-muted-foreground'
                }`}
              >
                {index < currentIndex ? (
                  <Icon name="Check" size={24} />
                ) : (
                  <Icon name={step?.icon} size={24} />
                )}
              </div>
              <p
                className={`text-xs mt-2 font-medium text-center ${
                  index <= currentIndex ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step?.label}
              </p>
            </div>

            {/* Connector Line */}
            {index < steps?.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 mb-6">
                <div
                  className={`h-full transition-all ${
                    index < currentIndex ? 'bg-success' : 'bg-muted'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;